export function canISeeMessenger( { advancedMessengerVisibility = true, visibilityCode = 'SHOW-CONTAINS', visibilityUrls = '/', hostData } ) {
    if(!advancedMessengerVisibility || !visibilityUrls)
        return { status: true, reason: 'Advanced messenger visibility is not set.' }
    
    const showHideCondition = visibilityCode.split('-')[0];
    const regexCondition = visibilityCode.split('-')[1];
    
    if(!showHideCondition) return { status: true, reason: 'Show hide condition is not set' }
    if(!regexCondition) return { status: true, reason: 'Show hide condition is not set' }
    const checkRegexMatch = () => {
        //this check for show condtion
        for(let eachUrl of visibilityUrls.split(',')) {
            
            if(!eachUrl) continue;

            let status = ''
            if(regexCondition === 'STARTS') {
                status = hostData.pathname.indexOf(eachUrl)
                if(status === 0) return true;
            }  else if(regexCondition === 'CONTAINS') {
                status = hostData.pathname.indexOf(eachUrl)
                if(status >= 0) return true;
            } else if(regexCondition === 'EXACT') {
                status = hostData.pathname === eachUrl || hostData.pathname === eachUrl+'/';
                if(status) return true;
            }
        }
        return false;
    }

    if(showHideCondition === 'SHOW')
        return { status: checkRegexMatch(), reason: 'SHOW condtion' }
    else if(showHideCondition === 'HIDE')
        return { status: !checkRegexMatch(), reason: 'HIDE condition ' } //simply negate the show condition value
    else return { status: true, reason: 'Not Show/Hide' } //if no conditions found display it

}
